// extracted by mini-css-extract-plugin
module.exports = {"reviewItem":"reviewItem_reviewItem__yk4zK","top":"reviewItem_top__eAbl_","date":"reviewItem_date__clAPs","comment":"reviewItem_comment__NYSbz"};